import React from 'react'
import { Tag, Typography } from 'antd'
import dayjs from 'dayjs'
import numeral from './numeralConfig'
// import numeral from 'numeral'

const { Paragraph } = Typography

export function renderNull () {
  return <span className="c-null">--</span>
}
export function renderNullStr () {
  return '--'
}
export function renderUnString () {
  return ''
}
export function renderArray () {
  return []
}
export function renderZero () {
  return <span className="c-null">0</span>
}
export function renderInfinite (text) {
  if (text === 0) { return '♾' }
  return '--'
}
export function renderUnBool () {
  return '否'
}

// ** --- 人名 ---
export function renderNameStr (en, cn) {
  return `${renderTextUn(en)} - ${renderTextUn(cn)}`
}
// ** --- 文案 ---
export function renderLabelString (text) {
  if (!text) { return renderUnString() }
  return <span className="customerTableTitle text-nowrap">{text}：</span>
}
export function renderLabel (text) {
  if (!text) { return renderNull() }
  return <span className="customerTableTitle text-nowrap">{text}：</span>
}
export function renderTitle (text) {
  if (!text) { return renderNull() }
  return <span className="customerTableTitle text-nowrap">{text}</span>
}
export function renderUNnowrapTitle (text) {
  if (!text) { return renderNull() }
  return <span className="customerTableTitle" style={{ fontSize: 13 }}>{text}</span>
}
export function renderText (text) {
  if (!text) { return renderNull() }
  return text
}
export function renderTextStr (text) {
  if (!text) {
    return renderNullStr()
  }
  if (typeof text === 'object') {
    if (text.$$typeof) {
      return text
    }
    if (Array.isArray(text)) {
      return text.length ? text.map((x) => renderTextStr(x)).join(', ') : renderNullStr()
    }
    if (text.desc != null && text.desc !== '') {
      return String(text.desc)
    }
    if (text.value != null && text.value !== '') {
      return String(text.value)
    }
    if (text.name != null && text.name !== '') {
      return String(text.name)
    }
    try {
      return JSON.stringify(text)
    } catch {
      return String(text)
    }
  }
  return text
}
/** 手机号脱敏：只显示前 3 位和后 4 位，中间 ****；空或不足 7 位返回 -- */
export function renderPhoneStr (text) {
  if (!text) { return renderNullStr() }
  const s = String(text).trim()
  if (!s) { return renderNullStr() }
  if (s.length < 7) { return renderNullStr() }
  return `${s.slice(0, 3)}****${s.slice(-4)}`
}
export function renderParenthesisText (text) {
  if (!text) { return renderNull() }
  return <span>（{text}）</span>
}
export function renderTextUn (text) {
  if (!text) { return renderUnString() }
  return text
}
export function renderCodeUn (text) {
  if (!text) { return renderUnString() }
  return `${text}_`
}
export function renderBoolStr (text) {
  if (!text) { return renderUnBool() }
  return '是'
}
// ** --- 文案 ---

// ** --- 数字 ---
export function renderCountOrGrayZero (raw) {
  const n = Number(raw)
  if (!raw || !Number.isFinite(n) || n === 0) {
    return renderZero()
  }
  return String(n)
}

export function renderNumeralStr (text) {
  if (!text) { return renderUnString() }
  return numeral(text).format('0,0.00')
}
export function renderNumeralIntStr (text) {
  if (!text) { return renderNull() }
  return numeral(text).format('0,0')
}
export function renderFormattedInt (text) {
  if (!text) { return 0 }
  return numeral(text).format('0,0')
}
export function renderDoubleStr (text) {
  if (!text) { return renderNull() }
  return numeral(text).format('00')
}
export function renderNumeralFix2 (text) {
  if (!text) { return 0 }
  return Number(text.toFixed(2))
  // return numeral(text).format('0.00')
}
export function renderNumeralAStr (text) {
  if (!text) { return renderUnString() }
  return numeral(text).format('0.00 a')
}

export function renderNumeralMStr (text) {
  if (!text) { return renderUnString() }
  return numeral(text).format('0.00 万')
}
export function renderIndex (text) {
  return text + 1
}
export function renderWorktime (text) {
  if (!text) { return renderZero() }
  return text
}
export function renderInfiniteStr (text) {
  if (!text) { return renderInfinite(text) }
  return text
}

// ** --- 百分数 ---
export function renderPer (text) {
  if (!text) { return renderNull() }
  return <span>{numeral(text).format('0%')}</span>
}
export function renderPerStr (text) {
  if (!text) { return renderNullStr() }
  return <span>{numeral(text).format('0%')}</span>
}
export function renderPer1 (text) {
  if (!text) { return renderNull() }
  return <span>{numeral(text).format('0.0%')}</span>
}
export function renderPer1Str (text) {
  if (!text) { return renderUnString() }
  return `${numeral(text).format('0.0%')}`
}
export function renderPer2 (text) {
  if (!text) { return renderNull() }
  return <span>{numeral(text).format('0.00%')}</span>
}
export function renderPer2Str (text) {
  if (!text) { return renderUnString() }
  return `${numeral(text).format('0.00%')}`
}
export function renderPer2Com0 (text) {
  if (text || text === 0) {
    return `${numeral(text).format('0.00%')}`
  }
  return renderNull()
}

export function renderPerMin0Str (text) {
  if (!text) { return renderUnString() }
  if (text < 0.09 && text > 0) { return '0.1%' }
  return `${numeral(text).format('0%')}`
}
export function renderPerMin (text) {
  if (!text) { return renderUnString() }
  if (text < 0.99 && text > 0) { return '0.1%' }
  return <span>{numeral(text).format('0%')}</span>
}
export function renderPerMinStr (text) {
  if (!text) { return renderUnString() }
  if (text < 0.99 && text > 0) { return '0.1%' }
  return `${numeral(text).format('0%')}`
}
export function renderTextPer (text) {
  if (!text) { return renderNull() }
  return <span>{text} %</span>
}
export function renderTextPerStr (text) {
  if (!text) { return renderUnString() }
  return `${text}%`
}
export function renderTextRadix (text) {
  if (text || text === 0) {
    return <span>{text} %</span>
  }
  if (!text) { return <span>♾</span> }
}

// ** --- 百分数 ---

// ** --- 钱 ---
export function renderMoney (text) {
  if (`${Number(text)}` === 'NaN') { return renderNull() }
  return `${numeral(text).format('0,0.00')}元`
}
export function renderMoneyStr (text) {
  if (`${Number(text)}` === 'NaN') { return renderNullStr() }
  return `${numeral(text).format('0,0.00')}元`
}
export function renderMoneyInt (text) {
  if (`${Number(text)}` === 'NaN') { return renderNull() }
  return `${numeral(text).format('0,0')}元`
}
export function renderRightMoney (text) {
  if (`${Number(text)}` === 'NaN') { return <span style={{ position: 'absolute', right: 0 }}> {renderNull()} </span> }
  return <span className='momey'>
    ¥ {numeral(text).format('0,0.00')}
  </span>
}

// ** --- 日期 ---
export function formatTitleDay (text) {
  if (!text) { return renderNull() }
  return <span className="customerTableTitle text-nowrap">{dayjs(text).format('YYYY-MM-DD')}</span>
}

export function formatDay (text) {
  if (!text) { return renderNull() }
  return <span>{dayjs(text).format('YYYY-MM-DD')}</span>
}

export function formatDayString (text) {
  if (!text) { return renderUnString() }
  if (typeof text === 'number') {
    return text.toString().length <= 10 ? dayjs.unix(text).format('YYYY-MM-DD') : dayjs(text).format('YYYY-MM-DD')
  }
  return dayjs(text).format('YYYY-MM-DD')
}
export function formatMonthDayString (text) {
  if (!text) { return renderUnString() }
  return dayjs(text).format('MM-DD')
}
export function formatMonthEnd (text) {
  if (!text) { return renderNull() }
  return <span>{dayjs(text).endOf('month')}</span>
}
export function fromatDayHM (text) {
  if (!text) { return renderNull() }
  // LTS	-> h:mm:ss A -> 8:02:18 PM
  return <span>{dayjs(text).format('YYYY-MM-DD / HH:mm')}</span>
}
export function fromatDayHMStr (text) {
  if (!text) { return renderUnString() }
  // LTS	-> h:mm:ss A -> 8:02:18 PM
  return dayjs(text).format('YYYY-MM-DD HH:mm')
}

export function formatDateTimeStr (datetime) {
  if (!datetime) { return renderUnString() }

  // 如果是数字，判断是秒级还是毫秒级时间戳
  if (typeof datetime === 'number') {
    // 如果时间戳小于 13 位，认为是秒级时间戳
    if (datetime.toString().length <= 10) {
      return dayjs.unix(datetime).format('YYYY-MM-DD HH:mm')
    } else {
      return dayjs(datetime).format('YYYY-MM-DD HH:mm')
    }
  }

  // 如果是字符串，尝试解析
  try {
    return dayjs(datetime).format('YYYY-MM-DD HH:mm')
  } catch (e) {
    return datetime
  }
}

/** 含秒：YYYY-MM-DD HH:mm:ss */
export function formatDateTimeSecondsStr (datetime) {
  if (!datetime) { return renderUnString() }

  if (typeof datetime === 'number') {
    if (datetime.toString().length <= 10) {
      return dayjs.unix(datetime).format('YYYY-MM-DD HH:mm:ss')
    } else {
      return dayjs(datetime).format('YYYY-MM-DD HH:mm:ss')
    }
  }

  try {
    return dayjs(datetime).format('YYYY-MM-DD HH:mm:ss')
  } catch (e) {
    return datetime
  }
}
export function formatDayjs (text) {
  if (!text) { return renderUnString() }
  return dayjs(+text)
}
export function formatDayjsStartOf (text) {
  if (!text) { return renderUnString() }
  return +dayjs(text).startOf('day')
}

// ** --- Tag ---
export function renderTag (text, color) {
  if (!text) { return renderUnString() }
  return <Tag color={color}>{text}</Tag>
}
export function renderTagList (list, color) {
  if (!list) { return renderUnString() }
  return list.map((item, index) => (
    <Tag key={`${index}-${item}`} color={color}>{item}</Tag>
  ))
}
// ** --- Tag ---

// ** --- 字符串 转换 数组
export function dataSplit (text, type) {
  console.log('text', text)
  if (!text) { return renderArray() }
  return text.split(`${type}`)
}
// ** --- 字符串 转换 数组

// ** --- Typography ---
export function renderParagraph (text) {
  if (!text) { return renderUnString() }
  return <Paragraph style={{ display: 'inline', color: '#4a4a4a' }} copyable>{text}</Paragraph>
}

// ** --- 产康单项目预约 / technician-day（纯函数）---

/** @returns {number} 可能为 NaN */
export function normalizeServiceMinutes (raw) {
  return Number(raw)
}

export function isValidServiceMinutes (minutes) {
  return Number.isFinite(minutes) && minutes > 0
}

export function hasTechnicianSelected (technicianId) {
  return technicianId != null && technicianId !== ''
}

/** 用于 technician-day 接口；无效时返回 null */
export function parseTechnicianIdForApi (raw) {
  if (raw == null || raw === '') return null
  const n = Number(raw)
  return Number.isFinite(n) && n > 0 ? n : null
}

/**
 * 未分配安排（GET /project-plan/unassigned）行上可能携带的月子中心订单 id，用于拉 order-total/{id}/detail。
 * 若后端字段名不同，在此补充候选键。
 * @param {object} planOrRow
 * @returns {string|number|undefined}
 */
export function resolveOrderTotalIdFromUnassignedPlan (planOrRow) {
  if (!planOrRow || typeof planOrRow !== 'object') return undefined
  const nested = planOrRow.orderTotal
  const fromNested = nested && typeof nested === 'object' ? nested.id : undefined
  const v =
    planOrRow.orderTotalId ??
    planOrRow.orderId ??
    planOrRow.memberOrderTotalId ??
    planOrRow.maternityOrderTotalId ??
    fromNested
  if (v == null || v === '') return undefined
  return v
}

/** 预约日 0 点毫秒时间戳 */
export function appointmentDateToDayStartMs (appointmentDate) {
  const d = appointmentDate != null ? dayjs(appointmentDate) : dayjs()
  return d.isValid() ? d.startOf('day').valueOf() : dayjs().startOf('day').valueOf()
}

/** 预约日 0 点 Unix 秒（10 位），部分 Java 接口 query.date 使用 */
export function appointmentDateToDayStartSec (appointmentDate) {
  return Math.floor(appointmentDateToDayStartMs(appointmentDate) / 1000)
}

/**
 * 自 0 点起的分钟数。支持：HH:mm、带日期字符串、以及 Unix 时间戳（秒/毫秒，取本地时:分，与表盘 15 分钟格对齐）
 * 对「0～1439」的纯数字按「自 0 点分钟数」处理（与 Java 下若误传分针值兼容，少见）
 * @param {string|number|null|undefined} s
 * @returns {number|null}
 */
function parseToClockMinutesFromMidnight (raw) {
  if (raw == null || raw === '' || (typeof raw === 'number' && !Number.isFinite(raw))) {
    return null
  }
  if (typeof raw === 'number' && raw >= 0 && raw < 24 * 60) {
    return Math.floor(raw)
  }
  if (typeof raw === 'number' && raw > 0) {
    const ms = raw < 1e12 ? raw * 1000 : raw
    const d = dayjs(ms)
    return d.isValid() ? d.hour() * 60 + d.minute() : null
  }
  const t = String(raw).trim()
  if (t === '') return null
  if (/^\d{10,13}$/.test(t)) {
    const n = Number(t)
    const ms = n < 1e12 ? n * 1000 : n
    const d = dayjs(ms)
    return d.isValid() ? d.hour() * 60 + d.minute() : null
  }
  return null
}

export function parseHmStringToDayMinutes (s) {
  if (s == null || s === '') return null
  if (typeof s === 'number' && Number.isFinite(s)) {
    if (s >= 0 && s < 24 * 60) return Math.floor(s)
    if (s > 0) {
      return parseToClockMinutesFromMidnight(s)
    }
    return null
  }
  const t = String(s).trim()
  const fromStamp = parseToClockMinutesFromMidnight(t)
  if (fromStamp != null) {
    return fromStamp
  }
  const p = dayjs(
    t,
    [
      'YYYY-MM-DD HH:mm:ss',
      'YYYY-MM-DD H:mm:ss',
      'YYYY-MM-DD HH:mm',
      'YYYY-MM-DD H:mm',
      'HH:mm:ss',
      'H:mm:ss',
      'HH:mm',
      'H:mm'
    ],
    true
  )
  if (p.isValid()) {
    return p.hour() * 60 + p.minute()
  }
  const m = t.match(/^(\d{1,2}):(\d{2})(?::\d{2})?/)
  if (m) {
    const h = Number(m[1])
    const min = Number(m[2])
    if (Number.isFinite(h) && h >= 0 && h < 24 && Number.isFinite(min) && min >= 0 && min < 60) {
      return h * 60 + min
    }
  }
  return null
}

/**
 * 同日内的 HH:mm 对 → 绝对毫秒区间（用于休息禁选等）
 * @param {import('dayjs').Dayjs|string|Date|number} appointmentDate
 * @param {string} startHm
 * @param {string} endHm
 * @returns {{ start: number, end: number }|null}
 */
export function buildHmRangeMsForAppointmentDay (appointmentDate, startHm, endHm) {
  if (!startHm || !endHm) return null
  const datePart = appointmentDatePart(appointmentDate)
  const a = dayjs(`${datePart} ${String(startHm).trim()}`, ['YYYY-MM-DD HH:mm', 'YYYY-MM-DD H:mm'], true)
  const b = dayjs(`${datePart} ${String(endHm).trim()}`, ['YYYY-MM-DD HH:mm', 'YYYY-MM-DD H:mm'], true)
  if (!a.isValid() || !b.isValid() || b.valueOf() <= a.valueOf()) return null
  return { start: a.valueOf(), end: b.valueOf() }
}

/**
 * GET /project-plan/technicians → TechnicianVO 列表
 * @param {object} res
 * @returns {Array<{
 *  technicianId: number, technicianName: string, shiftName?: string,
 *  startTime?: string, endTime?: string, restStartTime?: string, restEndTime?: string
 * }>}
 */
export function parseProjectPlanTechniciansData (res) {
  let raw
  if (Array.isArray(res)) {
    raw = res
  } else if (res && typeof res === 'object' && res.data !== undefined) {
    raw = res.data
  } else {
    raw = []
  }
  if (raw == null) return []
  return Array.isArray(raw) ? raw : []
}

const emptyShiftRest = {
  shiftStartMinutes: null,
  shiftEndMinutes: null,
  restStartMinutes: null,
  restEndMinutes: null
}

/**
 * 从 project-plan/technicians 单行解析上/下班与午休（分钟，自 0 点起；午休字段可缺省）
 */
export function getTechnicianShiftRestFromRow (row) {
  if (!row || typeof row !== 'object') {
    return { ...emptyShiftRest }
  }
  const startRaw =
    row.startTime ?? row.start ?? row.workStartTime ?? row.onDutyStartTime ?? row.shiftStartTime
  const endRaw = row.endTime ?? row.end ?? row.workEndTime ?? row.onDutyEndTime ?? row.shiftEndTime
  const restStartRaw =
    row.restStartTime ?? row.restStart ?? row.lunchStartTime ?? row.noonRestStartTime ?? row.breakStartTime
  const restEndRaw =
    row.restEndTime ?? row.restEnd ?? row.lunchEndTime ?? row.noonRestEndTime ?? row.breakEndTime
  const shiftStartMinutes = parseHmStringToDayMinutes(startRaw)
  const shiftEndMinutes = parseHmStringToDayMinutes(endRaw)
  let restStartMinutes = parseHmStringToDayMinutes(restStartRaw)
  let restEndMinutes = parseHmStringToDayMinutes(restEndRaw)
  if (
    restStartMinutes == null ||
    restEndMinutes == null ||
    !Number.isFinite(restStartMinutes) ||
    !Number.isFinite(restEndMinutes) ||
    restStartMinutes >= restEndMinutes
  ) {
    restStartMinutes = null
    restEndMinutes = null
  }
  return { shiftStartMinutes, shiftEndMinutes, restStartMinutes, restEndMinutes }
}

export function extractErrorMessage (err, fallback) {
  return err?.msg || err?.message || fallback
}

export function appointmentDatePart (appointmentDate) {
  if (!appointmentDate) return dayjs().format('YYYY-MM-DD')
  if (dayjs.isDayjs(appointmentDate)) return appointmentDate.format('YYYY-MM-DD')
  const parsed = dayjs(appointmentDate)
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : String(appointmentDate).slice(0, 10)
}

/** 预约日期 + 开始 HH:mm + 服务分钟 → 预计结束时间展示（同日仅 HH:mm，跨日带 MM-DD） */
export function formatExpectedEndTime (appointmentDate, startHm, durationMins) {
  if (!startHm || !Number.isFinite(durationMins) || durationMins <= 0) return null
  const datePart = appointmentDatePart(appointmentDate)
  const start = dayjs(`${datePart} ${startHm}`, 'YYYY-MM-DD HH:mm', true)
  if (!start.isValid()) return null
  const end = start.add(durationMins, 'minute')
  if (!end.isSame(start, 'day')) {
    return `${end.format('MM-DD')} ${end.format('HH:mm')}`
  }
  return end.format('HH:mm')
}

export function normalizeBookingTs (ts) {
  if (ts == null || ts === 0) return null
  const n = Number(ts)
  if (!Number.isFinite(n)) return null
  return n < 1e12 ? n * 1000 : n
}

/** 从 slotStart 起持续 serviceDurationMs 的预约窗口是否与任一已占用区间重叠 */
export function serviceWindowOverlapsBookedRanges (slotStartMs, serviceDurationMs, ranges) {
  if (!Array.isArray(ranges) || ranges.length === 0) return false
  const windowEndMs = slotStartMs + serviceDurationMs
  return ranges.some((seg) => {
    const s = normalizeBookingTs(seg.start)
    const e = normalizeBookingTs(seg.end)
    return s != null && e != null && s < e && slotStartMs < e && windowEndMs > s
  })
}

/**
 * technician-day 接口 → 统一为 { start, end }[]，时间戳支持秒/毫秒，字段兼容 startTime/endTime 等
 */
export function parseTechnicianDayPlanData (res) {
  let raw
  if (Array.isArray(res)) {
    raw = res
  } else if (res && typeof res === 'object' && res.data !== undefined) {
    raw = res.data
  } else {
    raw = []
  }
  if (raw == null) return []
  const arr = Array.isArray(raw) ? raw : (Array.isArray(raw?.records) ? raw.records : [])
  return arr.map((item) => {
    if (!item || typeof item !== 'object') return null
    const start = item.start ?? item.startTime ?? item.beginTime ?? item.stime
    const end = item.end ?? item.endTime ?? item.finishTime ?? item.etime
    if (start == null && end == null) return null
    return { start, end }
  }).filter(Boolean)
}

/** 某一 15 分钟格 [slotStartMs, slotStartMs+15min) 是否与已排期区间重叠（用于时间表标色） */
export function isFifteenMinuteSlotBusy (slotStartMs, bookedRanges) {
  if (!Array.isArray(bookedRanges) || bookedRanges.length === 0) return false
  if (!Number.isFinite(slotStartMs)) return false
  const w = 15 * 60 * 1000
  return bookedRanges.some((seg) => {
    const s = normalizeBookingTs(seg.start)
    const e = normalizeBookingTs(seg.end)
    return s != null && e != null && s < e && slotStartMs < e && (slotStartMs + w) > s
  })
}
